import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, ExternalLink } from "lucide-react";
import { useAdminApi, fmtDate } from "./useAdminApi";
import { PanelHeader } from "./LeadsPanel";
import BlogEditor from "./BlogEditor";
import { imgUrl } from "@/lib/api";

export default function BlogsPanel() {
  const api = useAdminApi();
  const [blogs, setBlogs] = useState(null);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/admin/blogs").then(setBlogs);
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const remove = async (b) => {
    if (!window.confirm(`Delete "${b.title}"?`)) return;
    await api.del(`/admin/blogs/${b.id}`);
    toast.success("Post deleted");
    load();
  };

  if (editing) return <BlogEditor post={editing === "new" ? null : editing} onDone={() => { setEditing(null); load(); }} />;

  return (
    <div data-testid="blogs-panel">
      <PanelHeader title="Blog" sub="Write with AI, add a cover image and publish SEO-ready articles.">
        <button onClick={() => setEditing("new")} className="inline-flex items-center gap-2 rounded-full bg-[#00C9B7] text-[#031312] px-5 py-3 text-xs font-bold uppercase tracking-widest hover:bg-[#00E0CC]" data-testid="blog-new-btn"><Plus size={16} /> New post with AI</button>
      </PanelHeader>
      <div className="rounded-2xl border border-[#00C9B7]/20 bg-[#00C9B7]/5 p-4 mb-6 text-sm text-slate-300" data-testid="sitemap-info">
        Google sitemap (updates automatically with every post, English + Spanish): <a href={`${window.location.origin}/api/sitemap.xml`} target="_blank" rel="noreferrer" className="text-[#00C9B7] underline break-all">{window.location.origin}/api/sitemap.xml</a> — submit it once in Google Search Console. New posts are translated to Spanish automatically.
      </div>
      {blogs === null ? <p className="text-slate-500">Loading…</p> : (
        <div className="space-y-3">
          {blogs.map((b) => (
            <div key={b.id} className="flex items-center gap-4 rounded-2xl bg-[#131B21] border border-white/5 p-3 pr-5" data-testid={`admin-blog-row-${b.slug}`}>
              <img src={imgUrl(b.cover_image) || "/img/sjds-beach.jpg"} alt="" className="w-20 h-16 sm:w-28 sm:h-20 rounded-xl object-cover shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="font-semibold truncate">{b.title}</p>
                <p className="text-xs text-slate-500 mt-1">{b.category} · {fmtDate(b.created_at)} · <span className={b.status === "published" ? "text-emerald-400" : "text-amber-400"}>{b.status}</span></p>
              </div>
              {b.status === "published" && <a href={`/blog/${b.slug}`} target="_blank" rel="noreferrer" className="text-slate-400 hover:text-white" title="View"><ExternalLink size={17} /></a>}
              <button onClick={() => setEditing(b)} className="text-slate-400 hover:text-[#00C9B7]" title="Edit" data-testid={`admin-blog-edit-${b.slug}`}><Pencil size={17} /></button>
              <button onClick={() => remove(b)} className="text-slate-400 hover:text-red-400" title="Delete" data-testid={`admin-blog-delete-${b.slug}`}><Trash2 size={17} /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
